import * as React from "react";
import { useContext } from "react";
import usePluginEntities from "hooks/usePluginEntities";
import FieldActionsContext from "views/components/actions/FieldActionsContext";
import useViewsDispatch from "views/stores/useViewsDispatch";
import useActiveQueryId from "views/hooks/useActiveQueryId";
import { Button } from "components/bootstrap";
import FieldTypesContext from "views/components/contexts/FieldTypesContext";
import AddToQueryHandler from "views/logic/valueactions/AddToQueryHandler";
const AssetDetailsActions = ({ assetId }) => {
  var _a;
  const { all } = useContext(FieldTypesContext);
  const fieldType = (_a = all.find((f) => f.name === "associated_assets")) == null ? void 0 : _a.type;
  const queryId = useActiveQueryId();
  const dispatch = useViewsDispatch();
  const handleAddToQuery = () => dispatch(AddToQueryHandler({ queryId, field: "associated_assets", value: assetId, type: fieldType }));
  return /* @__PURE__ */ React.createElement(Button, { bsSize: "xs", bsStyle: "primary", onClick: () => handleAddToQuery() }, "Add to query");
};
const ViewsFieldActionsProvider = ({ children }) => {
  const dispatch = useViewsDispatch();
  const queryId = useActiveQueryId();
  const valueActions = usePluginEntities("valueActions");
  const fieldActions = usePluginEntities("fieldActions");
  const additionalHandlerArgs = { queryId };
  const evaluateCondition = (condition, args, fallbackValue) => {
    if (!condition) {
      return fallbackValue;
    }
    return dispatch((_dispatch, stateGetter) => condition(args, stateGetter));
  };
  const executeThunkAction = (thunk, args) => Promise.resolve(dispatch(thunk(args)));
  const actionConfig = {
    evaluateCondition,
    executeThunkAction,
    additionalHandlerArgs,
    valueActions,
    fieldActions,
    assetDetailsActions: AssetDetailsActions
  };
  return /* @__PURE__ */ React.createElement(FieldActionsContext.Provider, { value: actionConfig }, children);
};
export default ViewsFieldActionsProvider;
